import http_config from '../../common/config/http_config';
import axiosInstance from '../../common/helper/axiosInterceptor';
import { LoginRequestModel, LoginResponseModel } from './auth.model';

export const onLogin = (payload: LoginRequestModel): Promise<LoginResponseModel> => {
  return axiosInstance.post(http_config.BASE_URL + '/auth/login', payload);
};
